import classNames from 'classnames';
import { css } from 'css-literal-loader/styled';
import React from 'react';

const styles = require('./Button-styles.module.scss');

function Button({ className, ...props }, ref) {
  const Component = props.href ? 'a' : 'button';

  return (
    <Component
      ref={ref}
      className={classNames(className, styles.button)}
      {...props}
    />
  );
}
export default React.forwardRef(Button);
